export default "__VITE_ASSET__12bcf9e0__"